// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Field.Common {
  position: relative;
}
.Field.Common[data-label]:before, .Field.Common[data-feedback]:after {
  display: inline-block;
  position: absolute;
  height: 0.75rem;
  width: fit-content;
  pointer-events: none;
  user-select: none;
  font-size: 0.75rem;
  padding: 0 0.25rem;
}
.Field.Common[data-label]:before {
  content: attr(data-label);
  top: -1px;
  left: 0.5rem;
  color: #666666;
  vertical-align: bottom;
  text-transform: uppercase;
  line-height: 1rem;
  padding: 0 0.35rem;
  z-index: 1;
}
.Field.Common[data-label]:has(.Input):before, .Field.Common[data-label]:has(.Textarea):before, .Field.Common[data-label]:has(.Dropdown):before, .Field.Common[data-label]:has(.dropdown):before {
  border-bottom: 1px solid #fff;
}
.Field.Common[data-feedback]:after {
  content: attr(data-feedback);
  bottom: 0;
  right: 0.5rem;
  color: #999999;
  vertical-align: top;
}
.Field.Common:has(.is-invalid)[data-feedback]:after, .Field.Common:has(.border-danger)[data-feedback]:after {
  color: #cc3333;
}
.Field.Common:has(.is-valid)[data-feedback]:after, .Field.Common:has(.border-success)[data-feedback]:after {
  color: #33aa33;
}`, "",{"version":3,"sources":["webpack://./src/common/Field/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EAEE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AACJ;AAEI;EACE,yBAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AAAN;AAEI;EAIE,6BAAA;AAHN;AAME;EACE,4BAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AAJJ;AAQI;EACE,cAAA;AANN;AAWI;EACE,cAAA;AATN","sourcesContent":[".Field.Common {\n  position: relative;\n  &[data-label]:before,\n  &[data-feedback]:after {\n    display: inline-block;\n    position: absolute;\n    height: 0.75rem;\n    width: fit-content;\n    pointer-events: none;\n    user-select: none;\n    font-size: 0.75rem;\n    padding: 0 0.25rem;\n  }\n  &[data-label] {\n    &:before {\n      content: attr(data-label);\n      top: -1px;\n      left: 0.5rem;\n      color: #666666;\n      vertical-align: bottom;\n      text-transform: uppercase;\n      line-height: 1rem;\n      padding: 0 0.35rem;\n      z-index: 1;\n    }\n    &:has(.Input):before,\n    &:has(.Textarea):before,\n    &:has(.Dropdown):before,\n    &:has(.dropdown):before {\n      border-bottom: 1px solid #fff;\n    }\n  }\n  &[data-feedback]:after {\n    content: attr(data-feedback);\n    bottom: 0;\n    right: 0.5rem;\n    color: #999999;\n    vertical-align: top;\n  }\n  &:has(.is-invalid),\n  &:has(.border-danger) {\n    &[data-feedback]:after {\n      color: #cc3333;\n    }\n  }\n  &:has(.is-valid),\n  &:has(.border-success) {\n    &[data-feedback]:after {\n      color: #33aa33;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
